import { MutationObserverOptions, useMutation, useQuery, UseQueryOptions } from '@tanstack/vue-query';
import { AxiosError } from 'axios';

import {
  DraftOrdersPostRequest,
  DraftOrdersPostResponse,
  FeatureEnrollmentPostRequest,
  ModifyPlanRequest,
  PlanSubscriptionsResponse,
  ProductsGetResponse,
} from '@/models/featureEnrollment';
import { draftOrders, enroll, modifyPlan, planSubscriptions, products } from '@/services/api/feature-enrollment';
import { PostPOSIntegrationRequestData, PostPOSIntegrationResponseData } from '@/services/api/models/settings';
import { postValidatePOSIntegration } from '@/services/api/settings';

type UseFeatureEnrollmentPostOptions = MutationObserverOptions<void, AxiosError, FeatureEnrollmentPostRequest>;

export function useFeatureEnrollmentPost(options?: UseFeatureEnrollmentPostOptions) {
  return useMutation({
    mutationFn: enroll,
    ...options,
  });
}

type UsePostValidatePOSIntegrationOptions = MutationObserverOptions<
  PostPOSIntegrationResponseData,
  AxiosError,
  PostPOSIntegrationRequestData
>;

export function useValidatePOSIntegrationPost(options?: UsePostValidatePOSIntegrationOptions) {
  return useMutation({
    mutationFn: postValidatePOSIntegration,
    ...options,
  });
}

type UseDraftOrdersPostOptions = MutationObserverOptions<DraftOrdersPostResponse, AxiosError, DraftOrdersPostRequest>;

export function useDraftOrdersPost(options?: UseDraftOrdersPostOptions) {
  return useMutation({
    mutationFn: draftOrders,
    ...options,
  });
}

type UseModifyPlanMutationOptions = MutationObserverOptions<void, AxiosError, ModifyPlanRequest>;

export function useModifyPlanMutation(options?: UseModifyPlanMutationOptions) {
  return useMutation({
    mutationFn: modifyPlan,
    ...options,
  });
}

type UseProductsQueryOptions = Partial<UseQueryOptions<ProductsGetResponse[]>>;

export function useProductsQuery(options?: UseProductsQueryOptions) {
  return useQuery({
    queryKey: ['feature-enrollment', 'products'],
    queryFn: products,
    ...options,
  });
}

type UsePlanSubscriptionsQueryOptions = Partial<UseQueryOptions<PlanSubscriptionsResponse>>;

export function usePlanSubscriptionsQuery(options?: UsePlanSubscriptionsQueryOptions) {
  return useQuery({
    queryKey: ['feature-enrollment', 'planSubscriptions'],
    queryFn: planSubscriptions,
    ...options,
  });
}
